import script from "./DiscussionInputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscussionInputComponent.vue?vue&type=script&setup=true&lang=js"

import "./DiscussionInputComponent.vue?vue&type=style&index=0&id=0975dcc2&lang=css"

const __exports__ = script;

export default __exports__